module.exports = __webpack_public_path__ + "static/media/LOGO_inspire.2718e0b5.png";